/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-lines */
import {
  Autocomplete,
  Box,
  createFilterOptions,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { OccupationListEN, OccupationListES } from './OccupationList';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { emplomentStyles as classes } from './EmploymentStyles';
import { OCC_PLACEHOLDER, REQUIRED, PROFESSION_DETAILS } from '../../../constants';
import { autoCompleteOccupation, commonTernary, isBundle } from '../../commonCode';
import { CommonStyles } from '../CommonStyles';
import { productMapping } from '../../../services/productMapping';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';

function SelfEmployed({ isBundleCompliance = false }) {
  const { t } = useTranslation();
  const [occupations, setOccupations] = useState([]);
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme, productName } = leadGenerationContext;
  const commonStyles = CommonStyles(leadGenerationContext?.theme);
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  useEffect(() => {
    if (leadGenerationContext.language === 'EN') {
      setOccupations(OccupationListEN());
    }
    if (leadGenerationContext.language === 'ES') {
      setOccupations(OccupationListES());
    }
  }, [leadGenerationContext.language]);

  const handleChange = (e) => {
    leadGenerationContext.setIsScreenFourDirty(true);
    leadGenerationContext.setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFeatureScreenDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    leadGenerationContext.setEmploymentInformation({
      ...leadGenerationContext.employmentInformation,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'employer') {
      if (e.target.value.length >= 2 && e.target.value.match(/^[A-Za-z0-9@&_.\-\s,()]*$/)) {
        leadGenerationContext.setEmploymentInformationErrors({
          ...leadGenerationContext.employmentInformationErrors,
          [e.target.name]: '',
        });
      } else if (e.target.value.length === 0) {
        leadGenerationContext.setEmploymentInformationErrors({
          ...leadGenerationContext.employmentInformationErrors,
          [e.target.name]: '* Mandatory Field',
        });
      } else {
        leadGenerationContext.setEmploymentInformationErrors({
          ...leadGenerationContext.employmentInformationErrors,
          [e.target.name]: '* Invalid Business Name',
        });
      }
    } else if (e.target.value.length === 0) {
      leadGenerationContext.setEmploymentInformationErrors({
        ...leadGenerationContext.employmentInformationErrors,
        [e.target.name]: '* Mandatory Field',
      });
    } else {
      leadGenerationContext.setEmploymentInformationErrors({
        ...leadGenerationContext.employmentInformationErrors,
        [e.target.name]: '',
      });
    }
  };

  const handleAutoCompleteChangeSelf = (name, value) => {
    autoCompleteOccupation(name, value, leadGenerationContext);
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option,
  });
  const sortedOccupation = [...occupations].sort((a, b) => a.localeCompare(b));

  return (
    <>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          htmlFor="employer"
          required={!isBundleCompliance}
          id="employer_label"
          data-testid="employer_label"
          aria-label={
            isBundleCompliance
              ? `${t('Business Name', {
                  defaultValue: 'Business Name',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
              : `${t('Name of your Business', {
                  defaultValue: 'Name of your Business',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
          }
          sx={commonStyles.label_title}
        >
          {isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.employer
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Business Name', {
                defaultValue: 'Business Name',
              })}
            </span>
          ) : (
            t('Name of your Business', {
              defaultValue: 'Name of your Business',
            })
          )}
        </InputLabel>
        <OutlinedInput
          id="employer"
          data-testid="employer_testid"
          name="employer"
          inputProps={{
            maxLength: 40,
            sx: {
              fontSize: '16px',
            },
          }}
          // sx={[
          //   commonStyles.outlined_inputs,
          //   classes.input_disabled_style,
          //   ...(isBundleCompliance && [
          //     classes.select_inputs_bundleBorder,
          //     commonStyles.outlined_input_bundle,
          //   ]),
          // ]}
          sx={[
            commonStyles.outlined_inputs,
            classes.input_disabled_style,
            ...(isBundleCompliance
              ? [
                  classes.select_inputs_bundleBorder,
                  commonStyles.outlined_input_bundle,
                  {
                    backgroundColor: leadGenerationContext.employmentInformationErrors.employer
                      ? '#D5151F1A'
                      : theme?.palette?.fieldsBackground?.main,
                    // border: leadGenerationContext.employmentInformationErrors.employer
                    //   ? `2px solid ${theme?.palette?.danger?.main}`
                    //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                  },
                ]
              : []),
          ]}
          slotProps={{
            notchedOutline: {
              sx:
                leadGenerationContext.employmentInformationErrors?.employer && !isBundleCompliance
                  ? commonStyles.notchedOutlineErr
                  : leadGenerationContext.employmentInformationErrors?.employer &&
                    isBundleCompliance
                  ? classes.outline_inputs_err_bundle
                  : commonStyles.notchedOutline,
            },
            input: {
              sx: isBundle(productName) && {
                '::-moz-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  fontSize: '16px',
                  opacity: 1,
                },
                '::-webkit-input-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
                '::-ms-input-placeholder': {
                  color: theme?.palette?.fieldsPlaceholder?.main,
                  opacity: 1,
                },
              },
            },
          }}
          onChange={handleChange}
          placeholder={
            isBundleCompliance
              ? t('Enter the name of your business', {
                  defaultValue: 'Enter the name of your business',
                })
              : t('Enter Business Name', {
                  defaultValue: 'Enter Business Name',
                })
          }
          fullWidth
          value={
            leadGenerationContext.employmentInformation?.employer
              ? leadGenerationContext.employmentInformation.employer
              : ''
          }
          autoComplete="off"
        />
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          role="alert"
          data-testid="employer_errorid"
        >
          {t(leadGenerationContext.employmentInformationErrors?.employer, {
            defaultValue: leadGenerationContext.employmentInformationErrors?.employer,
          })}
        </Box>
      </Grid>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          htmlFor="occupation"
          required={!isBundleCompliance}
          id="occupation_label"
          aria-label={
            isBundleCompliance
              ? `${t('Profession', { defaultValue: 'Profession' })} ${t(REQUIRED, {
                  defaultValue: REQUIRED,
                })}`
              : `${t('Occupation', { defaultValue: 'Occupation' })} ${t(REQUIRED, {
                  defaultValue: REQUIRED,
                })}`
          }
          sx={commonStyles.label_title}
          data-testid="occupation_label"
        >
          {productMapping(leadGenerationContext.productName) === 'Elite Account' ||
          productMapping(leadGenerationContext.productName) === 'Libre' ||
          productMapping(leadGenerationContext.productName) === 'Ahorra' ? (
            t('OccupationProg', {
              defaultValue: 'Occupation',
              nsSeparator: '|',
            })
          ) : isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.occupation
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Profession', { defaultValue: 'Profession' })}
            </span>
          ) : (
            t('Occupation', { defaultValue: 'Occupation' })
          )}
        </InputLabel>
        <Autocomplete
          data-testid="autocomplete"
          id="occupation"
          options={sortedOccupation}
          name="occupation"
          value={
            leadGenerationContext.employmentInformation?.occupation
              ? leadGenerationContext.employmentInformation.occupation
              : null
          }
          getOptionLabel={(option) => option}
          onChange={(event, selectedValue) => {
            handleAutoCompleteChangeSelf('occupation', selectedValue);
          }}
          filterOptions={filterOptions}
          renderInput={(params) => (
            <OutlinedInput
              ref={params.InputProps.ref}
              inputProps={{
                ...params.inputProps,
                style: { fontSize: '16px' },
              }}
              name="occupation"
              id="occupation"
              placeholder={
                isBundleCompliance
                  ? t(PROFESSION_DETAILS, {
                      defaultValue: PROFESSION_DETAILS,
                    })
                  : t(OCC_PLACEHOLDER, {
                      defaultValue: OCC_PLACEHOLDER,
                    })
              }
              sx={[
                commonStyles.outlined_inputs,
                ...(isBundleCompliance
                  ? [
                      classes.select_inputs_bundleBorder,
                      commonStyles.outlined_input_bundle,
                      {
                        backgroundColor: leadGenerationContext.employmentInformationErrors
                          .occupation
                          ? '#D5151F1A'
                          : theme?.palette?.fieldsBackground?.main,
                        // border: leadGenerationContext.employmentInformationErrors.occupation
                        //   ? `2px solid ${theme?.palette?.danger?.main}`
                        //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                      },
                    ]
                  : []),
                {
                  padding: !isBundleCompliance && '11.5px 14px !important',
                  fontSize: '16px',
                },
              ]}
              slotProps={{
                notchedOutline: {
                  sx:
                    leadGenerationContext.employmentInformationErrors?.occupation &&
                    !isBundleCompliance
                      ? commonStyles.notchedOutlineErr
                      : leadGenerationContext.employmentInformationErrors?.occupation &&
                        isBundleCompliance
                      ? classes.outline_inputs_err_bundle
                      : commonStyles.notchedOutline,
                },
                input: {
                  sx: isBundle(productName) && {
                    padding: '14px 14px 10px 14px !important',
                    '::-moz-placeholder': {
                      color: `${theme?.palette?.fieldsPlaceholder?.main} !important`,
                      opacity: 1,
                    },
                    '::placeholder': {
                      color: `${theme?.palette?.fieldsPlaceholder?.main} !important`,
                      fontSize: '16px',
                      opacity: 1,
                    },
                    '::-webkit-input-placeholder': {
                      color: `${theme?.palette?.fieldsPlaceholder?.main} !important`,
                      opacity: 1,
                    },
                    '::-ms-input-placeholder': {
                      color: `${theme?.palette?.fieldsPlaceholder?.main} !important`,
                      opacity: 1,
                    },
                  },
                },
              }}
              value={
                leadGenerationContext.employmentInformation?.occupation
                  ? leadGenerationContext.employmentInformation.occupation
                  : ''
              }
              fullWidth
            />
          )}
          slotProps={{
            paper: {
              sx: {
                backgroundColor: theme?.menuBackground,
                color: theme?.palette?.primary?.main,
              },
            },
          }}
        />
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          role="alert"
          data-testid="ocuupation_errorid"
        >
          {t(leadGenerationContext.employmentInformationErrors?.occupation, {
            defaultValue: leadGenerationContext.employmentInformationErrors?.occupation,
          })}
        </Box>
      </Grid>
      <Grid
        size={isBundleCompliance ? 12 : { xs: 12, md: 6 }}
        sx={commonTernary(
          !isBundleCompliance,
          classes.employment_select_field_padding,
          classes.bundle_employment_select_field
        )}
      >
        <InputLabel
          required={!isBundleCompliance}
          htmlFor="annualIncome"
          data-testid="annualIncome_label"
          id="annualIncome_label"
          sx={{
            ...commonStyles.label_title,
          }}
          aria-label={
            isBundleCompliance
              ? `${t('Annual income', {
                  defaultValue: 'Annual income',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
              : `${t('Annual Income', {
                  defaultValue: 'Annual Income',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`
          }
        >
          {isBundleCompliance ? (
            <span
              style={{
                color: leadGenerationContext.employmentInformationErrors?.annualIncome
                  ? 'red'
                  : 'inherit',
              }}
            >
              {t('Annual income', { defaultValue: 'Annual income' })}
            </span>
          ) : (
            t('Annual Income', { defaultValue: 'Annual Income' })
          )}
        </InputLabel>
        <Select
          data-testid="select_testid"
          id="annualIncome"
          role="listbox"
          name="annualIncome"
          variant="outlined"
          fullWidth
          IconComponent={() => (
            <Box padding="0 10px 0 0">
              <DownArrowIcon
                style={{ width: 24, height: 24 }}
                color={theme?.palette?.orientalPrimary?.main}
              />
            </Box>
          )}
          MenuProps={{
            disableScrollLock: true,
            PaperProps: {
              sx: {
                ...theme?.menuBackground,
                border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
                color: theme?.palette?.primary?.main,
              },
              className: isBundle(productName) ? 'bundle-menu-paper' : '',
            },
          }}
          // sx={[
          //   classes.select_inputs,
          //   leadGenerationContext.employmentInformationErrors?.annualIncome &&
          //     !isBundleCompliance &&
          //     classes.select_inputs_err,
          //   leadGenerationContext.employmentInformationErrors?.annualIncome &&
          //     isBundleCompliance &&
          //     classes.select_inputs_err_bundle,
          //   !leadGenerationContext.employmentInformation?.annualIncome && {
          //     color: '#808285',
          //   },
          //   ...(isBundleCompliance && [
          //     classes.select_inputs_bundleBorder,
          //     commonStyles.outlined_input_bundle,
          //   ]),
          // ]}
          sx={[
            classes.select_inputs,
            leadGenerationContext.employmentInformationErrors?.annualIncome && !isBundleCompliance
              ? classes.select_inputs_err
              : null,
            leadGenerationContext.employmentInformationErrors?.annualIncome && isBundleCompliance
              ? classes.select_inputs_err_bundle
              : null,
            !leadGenerationContext.employmentInformation?.annualIncome
              ? { color: '#808285' }
              : null,
            ...(isBundleCompliance
              ? [
                  classes.select_inputs_bundleBorder,
                  commonStyles.outlined_input_bundle,
                  {
                    backgroundColor: leadGenerationContext.employmentInformationErrors.annualIncome
                      ? '#D5151F1A'
                      : theme?.palette?.fieldsBackground?.main,
                    // border: leadGenerationContext.employmentInformationErrors.annualIncome
                    //   ? `2px solid ${theme?.palette?.danger?.main}`
                    //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                    color: !leadGenerationContext.employmentInformation?.annualIncome
                      ? theme?.palette?.fieldsPlaceholder?.main
                      : theme?.palette?.primary?.main,
                  },
                ]
              : []),
          ]}
          aria-label={t('Annual Income Aria Label', {
            defaultValue: 'Annual Income Required Please Select Annual Income dropdown menu button',
          })}
          slotProps={{
            icon: {
              sx: classes.select_icon,
            },
            select: {
              sx:
                !leadGenerationContext.employmentInformation?.annualIncome ||
                leadGenerationContext.employmentInformation?.annualIncome === 'Please Select'
                  ? classes.select_inputs_placeholder
                  : classes.select_style,
            },
          }}
          onChange={handleChange}
          value={
            leadGenerationContext.employmentInformation?.annualIncome
              ? leadGenerationContext.employmentInformation.annualIncome
              : ''
          }
          displayEmpty
        >
          <MenuItem value="" role="option">
            {isBundleCompliance
              ? t('Select your annual income', { defaultValue: 'Select your annual income' })
              : t('Select Annual Income', { defaultValue: 'Select Annual Income' })}
          </MenuItem>
          <MenuItem value="Less than $30,000" role="option">
            {t('Less than', { defaultValue: 'Less than' })} $30,000
          </MenuItem>
          <MenuItem value="$30,000 - $49,999" role="option">
            {t('$30,000 - $49,999', { defaultValue: '$30,000 - $49,999' })}
          </MenuItem>
          <MenuItem value="$50,000 - $74,999" role="option">
            {t('$50,000 - $74,999', { defaultValue: '$50,000 - $74,999' })}
          </MenuItem>
          <MenuItem value="$75,000 - $99,999" role="option">
            {t('$75,000 - $99,999', { defaultValue: '$75,000 - $99,999' })}
          </MenuItem>
          <MenuItem value="$100,000 - $199,999" role="option">
            {t('$100,000 - $199,999', { defaultValue: '$100,000 - $199,999' })}
          </MenuItem>
          <MenuItem value="$200,000 or More" role="option">
            $200,000 {t('or More', { defaultValue: 'or More' })}
          </MenuItem>
        </Select>
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          role="alert"
          data-testid="select_errorid"
        >
          {t(leadGenerationContext.employmentInformationErrors?.annualIncome, {
            defaultValue: leadGenerationContext.employmentInformationErrors?.annualIncome,
          })}
        </Box>
      </Grid>
    </>
  );
}

export default SelfEmployed;

SelfEmployed.propTypes = {
  isBundleCompliance: PropTypes.bool,
};
